import React from 'react'
import { Baffo } from '../Icons'
import styles from './IntroTitle.module.sass'

interface Props {
  label?: string
  className?: string
}

const IntroTitle = (props: Props) => {

  const { 
    label = '',
    className = '',
  } = props

  return label ? (
    <p className={`${styles.introTitle} ${className}`}>
      <span className={styles.label}>{label}</span>
    </p>
  ) : <></>
}

export default IntroTitle
